"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCodegenList = getCodegenList;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

/**
 * 查询待生成代码列表
 * @param pram
 */
function getCodegenList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit,
    tableName: pram.tableName
  };
  return (0, _request.default)({
    url: '/codegen/list',
    method: 'GET',
    params: data
  });
}